import { YattaLinkBase, isYattaLinkBase } from '../../link';

export interface NotificationActionLink extends YattaLinkBase {
  action: object;
}

export function isNotificationActionLink(value: unknown): value is NotificationActionLink {
  return typeof value === 'object' && value !== null && 'action' in value && typeof value.action === 'object' && isYattaLinkBase(value);
}

export const buildNotificationActionLink = (action: object, cssClass?: string, id?: string): NotificationActionLink => ({ action, class: cssClass, id });
